const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((webVitals) => {
      // Handle web-vitals v2+ API (uses getCLS, getFID, etc. instead of onCLS, onFID)
      // Also handle v1 API for backwards compatibility
      try {
        if (webVitals.onCLS && typeof webVitals.onCLS === 'function') {
          // v1 API
          webVitals.onCLS(onPerfEntry);
          webVitals.onFID && typeof webVitals.onFID === 'function' && webVitals.onFID(onPerfEntry);
          webVitals.onFCP && typeof webVitals.onFCP === 'function' && webVitals.onFCP(onPerfEntry);
          webVitals.onLCP && typeof webVitals.onLCP === 'function' && webVitals.onLCP(onPerfEntry);
          webVitals.onTTFB && typeof webVitals.onTTFB === 'function' && webVitals.onTTFB(onPerfEntry);
        } else if (webVitals.getCLS && typeof webVitals.getCLS === 'function') {
          // v2+ API
          webVitals.getCLS(onPerfEntry);
          webVitals.getFID && typeof webVitals.getFID === 'function' && webVitals.getFID(onPerfEntry);
          webVitals.getFCP && typeof webVitals.getFCP === 'function' && webVitals.getFCP(onPerfEntry);
          webVitals.getLCP && typeof webVitals.getLCP === 'function' && webVitals.getLCP(onPerfEntry);
          webVitals.getTTFB && typeof webVitals.getTTFB === 'function' && webVitals.getTTFB(onPerfEntry);
          webVitals.getINP && typeof webVitals.getINP === 'function' && webVitals.getINP(onPerfEntry);
        }
      } catch (err) {
        console.warn('Web vitals reporting error:', err);
      }
    }).catch((err) => {
      // Silently fail if web-vitals can't be loaded
      console.warn('Web vitals module failed to load:', err);
    });
  }
};

export default reportWebVitals;

